const userKey = 'user-data' // indice name
const themeKey = 'vuetify-theme-dark'

export const getUserData = userKey => JSON.parse(localStorage.getItem(userKey))

export const putUserData = (content, jsonFormat = false, userKey) => {
  if (jsonFormat) return localStorage.setItem(userKey, JSON.stringify(content))
  if (!jsonFormat) return localStorage.setItem(userKey, content)
}

export const updateUserData = updateObj => {
  const currentData = getUserData()
  const dataUpdated = {
    ...currentData,
    ...updateObj,
  }

  putUserData(dataUpdated, true)
}

export const removeUserData = userKey => localStorage.removeItem(userKey)

export const AmILogged = () => {
  const userData = getUserData()

  return !(!userData || !userData.id || !userData.name)
}

export const themeHandler = (action, $vuetify) => {
  if (action === 'get') {
    const darkTheme = localStorage.getItem(themeKey)
    if (darkTheme === 'enabled') $vuetify.theme.dark = true
  }
  if (action === 'put') {
    const darkThemeStatus = $vuetify.theme.dark ? 'disabled' : 'enabled'
    localStorage.setItem(themeKey, darkThemeStatus)
  }
}

export const AmIAdmin = () => {
  const userData = getUserData()

  return (userData && userData.isAdmin === true)
}
